// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type ChevronUp40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const ChevronUp40: FC<ChevronUp40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="m32 22.762-2.014 2.476L20 17.066l-9.986 8.172L8 22.762l12-9.828 12 9.828Z" />
        </svg>
    );
};

export default ChevronUp40;
